"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    submissions: {
        path: "/submissions",
    },
    createSubmission: {
        path: "/submissions/create/:submissionTypeId/:objectId?/",
    },
    viewSubmission: {
        path: "/submissions/:submissionId",
    },
    editSubmission: {
        path: "/submissions/:submissionId/edit",
    },
    submissionSummary: {
        path: "/submissions/:submissionId/summary",
    },
    inspections: {
        path: "/inspections",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VibWlzc2lvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3N1Ym1pc3Npb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsV0FBVyxFQUFFO1FBQ1gsSUFBSSxFQUFFLGNBQWM7S0FDckI7SUFDRCxnQkFBZ0IsRUFBRTtRQUNoQixJQUFJLEVBQUUsbURBQW1EO0tBQzFEO0lBQ0QsY0FBYyxFQUFFO1FBQ2QsSUFBSSxFQUFFLDRCQUE0QjtLQUNuQztJQUNELGNBQWMsRUFBRTtRQUNkLElBQUksRUFBRSxpQ0FBaUM7S0FDeEM7SUFDRCxpQkFBaUIsRUFBRTtRQUNqQixJQUFJLEVBQUUsb0NBQW9DO0tBQzNDO0lBQ0QsV0FBVyxFQUFFO1FBQ1gsSUFBSSxFQUFFLGNBQWM7S0FDckI7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIHN1Ym1pc3Npb25zOiB7XG4gICAgcGF0aDogXCIvc3VibWlzc2lvbnNcIixcbiAgfSxcbiAgY3JlYXRlU3VibWlzc2lvbjoge1xuICAgIHBhdGg6IFwiL3N1Ym1pc3Npb25zL2NyZWF0ZS86c3VibWlzc2lvblR5cGVJZC86b2JqZWN0SWQ/L1wiLFxuICB9LFxuICB2aWV3U3VibWlzc2lvbjoge1xuICAgIHBhdGg6IFwiL3N1Ym1pc3Npb25zLzpzdWJtaXNzaW9uSWRcIixcbiAgfSxcbiAgZWRpdFN1Ym1pc3Npb246IHtcbiAgICBwYXRoOiBcIi9zdWJtaXNzaW9ucy86c3VibWlzc2lvbklkL2VkaXRcIixcbiAgfSxcbiAgc3VibWlzc2lvblN1bW1hcnk6IHtcbiAgICBwYXRoOiBcIi9zdWJtaXNzaW9ucy86c3VibWlzc2lvbklkL3N1bW1hcnlcIixcbiAgfSxcbiAgaW5zcGVjdGlvbnM6IHtcbiAgICBwYXRoOiBcIi9pbnNwZWN0aW9uc1wiLFxuICB9LFxufSk7XG4iXX0=